// extracted by mini-css-extract-plugin
export var changeIcon = "_52-4";
export var clickable = "_52-8";
export var container = "_52-0";
export var divider = "_52-7";
export var externalLinkIcon = "_52-1";
export var green = "_52-5";
export var helpCircleIcon = "_52-3";
export var iconButton = "_52-2";
export var red = "_52-6";